import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;

export const getShippingCost = async (destinationPincode) => {
  const originPincode = 500030; // static origin pincode
  const url = `${baseUrl}/api/Distance/GetDistance?originPincode=${originPincode}&destinationPincode=${destinationPincode}`;

  try {
    const response = await axios.get(url);
    // You can check for a successful status code if needed:
    if (response.status !== 200) {
      throw new Error("Failed to fetch shipping cost");
    }
    // Axios automatically parses the response as JSON
    return response.data;
  } catch (error) {
    console.error("Error in getShippingCost:", error);
    throw error;
  }
};
